var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 31,
  height: 23
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Customer Supplied top / under mount Sink"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 285",
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 23,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 30.5,
  height: 22.5,
  rx: 3.75,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 216"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 286",
  fill: "none",
  stroke: "#4e4e4e",
  strokeWidth: 0.5,
  transform: "translate(1.999 5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 16,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 12.5,
  height: 15.5,
  rx: 1.75
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 217"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 286",
  transform: "translate(15.999 5)",
  fill: "none",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 16,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 12.5,
  height: 15.5,
  rx: 1.75
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 295",
  transform: "translate(10.545 2)",
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 1.5,
  height: 1.5,
  rx: 0.75,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 296",
  transform: "translate(14.061 2)",
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 1.5,
  height: 1.5,
  rx: 0.75,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 297",
  transform: "translate(17.576 2)",
  fill: "#fff",
  stroke: "#4e4e4e",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 1.5,
  height: 1.5,
  rx: 0.75,
  fill: "none"
})))));
export default SvgSink;